export const formatHeat = (heat: number): string => {
  if (heat >= 10000) {
    const value = heat / 10000;
    return `${value.toFixed(value >= 100 ? 0 : 1)}万`;
  }
  return String(heat);
};

export const formatDate = (value: string): string => {
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return value;
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
};

export const formatShortDate = (value: string): string => {
  const parts = value.split("-");
  if (parts.length < 3) return value;
  return `${Number(parts[1])}/${Number(parts[2])}`;
};